import React from 'react';
import classes from './ProfileIcon.module.scss';
import account from '../assets/account.jpg';

const ProfileIcon = (props) => {
    return (
        <div className={classes.profile}>

            <div className={classes.info}>
                <p><b>{props.email}</b></p>
            </div>
            <img src={account} alt={''}/>
        </div>
    );
};

export default ProfileIcon;